import { call, put, takeLatest } from "redux-saga/effects";
import {
  InitAction,
  PettyCashierOverallCostDetailAction
} from "../../../actions";
import * as types from "../../../actions/actionTypes";
import * as overallCostDetailApi from "../../../api/overallCost/detail/pettyCashierOverallCostDetail";
import { toastr } from "react-redux-toastr";
import * as receiveApi from "../../../api/receive/pettyCashierReceive";
import * as paymentApi from "../../../api/payment/pettyCashierPayment";
import { PAYMENT, RECEIVE } from "../../../constants/accountReviewTypes";
import { GetFilterDetail } from "../../../hocs/costClassificationReport/components/filter/tools";
import { SetMessage } from "../../../assets/errorMessages";

const RECEIVE_TYPE = RECEIVE;
const PAYMENT_TYPE = PAYMENT;

export function* pettyCashierWatcherOverallCostDetail() {
  yield takeLatest(types.PETTY_CASHIER_GET_OVERALL_COST_DETAIL_REQUEST, worker);
  yield takeLatest(
    types.PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_REQUEST,
    removeWorker
  );
}

async function fetchList(pageNumber = null) {
  const page_number = pageNumber ? pageNumber : "";
  return overallCostDetailApi.getList(page_number, GetFilterDetail());
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.pageNumber);
    yield put(PettyCashierOverallCostDetailAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(PettyCashierOverallCostDetailAction.getFailure(message));
  }
}

async function remove(id, type) {
  if (type == RECEIVE_TYPE) return receiveApi.remove(id);
  else if (type == PAYMENT_TYPE) return paymentApi.remove(id);
}

function* removeWorker(action) {
  try {
    const res = yield call(remove, action.id, action._type);
    const messages = res.data.message || res.message;
    messages.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const response = yield call(fetchList, action.pageNumber);
    yield put(PettyCashierOverallCostDetailAction.removeSuccess(response.data));
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
  } catch (error) {
    let messages = null;
    if (error.response) {
      if (error.response.data && error.response.data.message) {
        messages = error.response.data.message;
      } else if (error.response.message) {
        messages = error.response.message;
      }
    }
    messages &&
      Array.isArray(messages) &&
      messages.forEach(message => {
        toastr.error(" ", message.toString());
      });
    // dispatch a failure action to the store with the error
    yield put(PettyCashierOverallCostDetailAction.removeFailure(error));
  }
}
